export const OfficeCustomEquipmentCreateState = {
	url: '/custom-equipment-create/:component_id/:component_label',
	template: '<custom-equipment-create-page></custom-equipment-create-page>',
	params: {component_id: null, component_label: null, component_capacities: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeCustomEquipCreatePageMod" */
			'@Containers/office-custom-equipment-page/office-custom-equipment-create.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
